import type { ReactNode } from 'react';

import { ThemeProvider } from '../shared/theme/index';

/**
 * Provider composition — the dependency-wiring seam of the App Shell
 * (FE-1 Stage Work Item §4.1 B).
 *
 * It composes infrastructure providers only. FE1-W0 has exactly one (theme); a
 * data, routing or adapter provider would belong to a later authorized increment,
 * and adding one here would exceed the FE1-W0-A surface.
 *
 * Providers are nested outermost-first so that a provider may depend on any
 * provider above it and on none below.
 */

export interface ProvidersProps {
  readonly children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return <ThemeProvider>{children}</ThemeProvider>;
}
